import { useGtm } from '@gtm-support/vue2-gtm'
import pick from 'lodash/pick'
import dayjs from 'dayjs'
import router from '@/router'
import store from '@/store'
import StorageService from '@/services/storage-service'
import UserAPIs from '@/API/user-api'

const CAMPAIGN_KEYS = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_term', 'utm_content', 'coupon_code', 'package']
const UTM_KEYS = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_term', 'utm_content']

export const MARKETING_EVENTS = {
  // Registration events
  REGISTER_BEGIN: 'Signup Started',
  REGISTER_COMPLETE: 'signup_completed',
  // Purchase events
  PURCHASE_BEGIN: 'Started Checkout',
  PURCHASE_COMPLETE: 'purchase',
  PURCHASE_FAILED: 'Uncompleted Checkout',
  // Other events
  MENU_BUILD: 'Started Building Menu',
  WIZARD_COMPLETED: 'Steps Completed',
}

class MarketingService {
  static async triggerEvent(event: string, category: string, label = '', value: any = undefined, delay = 0) {
    try {
      if (delay) {
        await (new Promise((resolve: any) => setTimeout(resolve, delay)))
      }

      const gtm = useGtm ? useGtm() : undefined

      if (!gtm) {
        console.error('[GTM]: GTM is not initialized right')
        return
      }

      gtm.trackEvent({
        event,
        category,
        label,
        value,
        action: 'click',
      })
    } catch (error) {
      console.error('[GTM]: GTM trigger event failed', error)
    }
  }

  static getCampaign(withoutStore = false) {
    if (store.getters['auth/impersonate']) return null

    const route = router.currentRoute

    if (store.getters['auth/userUtm'] && !withoutStore) {
      return pick(store.getters['auth/userUtm'], CAMPAIGN_KEYS)
    }

    if (route?.query?.utm_campaign) {
      return pick(route.query, CAMPAIGN_KEYS)
    }

    return StorageService.getItem('okmenu_campaign', null, -1)
  }

  static getUtm(withoutStore = true) {
    const campaign = this.getCampaign(withoutStore)
    const utm = campaign ? pick(campaign, UTM_KEYS) : null
    if (!utm) return null
    return utm
  }

  static sendUtm() {
    const campaign = this.getCampaign(true)
    const utm = campaign ? pick(campaign, UTM_KEYS) : null
    if (!utm) return
    UserAPIs.sendUtm(utm).then(() => store.commit('auth/SET_UTM', utm)).catch(error => { console.error(error) })
  }

  static storeCampaign(campaign: any) {
    if (store.getters['auth/impersonate']) return null

    if (!campaign) {
      return StorageService.removeItem('okmenu_campaign')
    }

    return StorageService.setItem('okmenu_campaign', campaign, dayjs().add(1, 'hour').toDate(), -1)
  }

  static getPendingRoute() {
    const campaign = this.getCampaign()
    if (!campaign || !campaign.coupoun_code) return null
    const currentQuery = router?.currentRoute?.query ?? {}
    return { name: 'billing:plans', query: { ...currentQuery, ...campaign } }
  }
}

export default MarketingService
